<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <div class="my-auto mb-2">
          <h6 class="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
            <router-link to="/employee/employee-list">
              <i class="ti ti-arrow-left me-2"></i>All Employees
            </router-link>
          </h6>
        </div>
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="head-icons ms-2">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <div v-if="loading" class="alert alert-info">Loading employee…</div>
      <div v-else-if="!employee" class="alert alert-warning">
        Employee not found.
      </div>

      <div v-else class="row">
        <!-- LEFT -->
        <div class="col-xl-4 theiaStickySidebar">
          <div class="card card-bg-1 dq-employee-profile-card">
            <div class="card-body p-0">
              <span
                class="avatar avatar-xl avatar-rounded border border-2 border-white m-auto d-flex mb-2"
              >
                <img
                  :src="employee.avatar_url || placeholderAvatar"
                  class="w-auto h-auto"
                  alt="Img"
                />
              </span>

              <div class="text-center px-3 pb-3 border-bottom">
                <div class="mb-3">
                  <h5
                    class="d-flex align-items-center justify-content-center mb-1"
                  >
                    {{ fullName }}
                    <i
                      v-if="employee.status === 'Active'"
                      class="ti ti-discount-check-filled text-success ms-1"
                    ></i>
                  </h5>

                  <span class="badge badge-soft-dark fw-medium me-2">
                    <i class="ti ti-point-filled me-1"></i
                    >{{ employee.designation?.name || "—" }}
                  </span>
                  <span
                    v-if="experienceLabel"
                    class="badge badge-soft-secondary fw-medium"
                    >{{ experienceLabel }}</span
                  >
                </div>

                <div>
                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <span class="d-inline-flex align-items-center">
                      <i class="ti ti-id me-2"></i>Employee ID
                    </span>
                    <p class="text-dark">{{ employee.employee_id }}</p>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <span class="d-inline-flex align-items-center">
                      <i class="ti ti-star me-2"></i>Team
                    </span>
                    <p class="text-dark">
                      {{ employee.department?.name || "—" }}
                    </p>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <span class="d-inline-flex align-items-center">
                      <i class="ti ti-layout-grid me-2"></i>Section
                    </span>
                    <p class="text-dark">
                      {{ employee.section?.name || "—" }}
                    </p>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <span class="d-inline-flex align-items-center">
                      <i class="ti ti-user-check me-2"></i>Reports to
                    </span>
                    <p class="text-dark">
                      {{
                        employee.manager_name ||
                        [employee.manager?.first_name, employee.manager?.last_name]
                          .filter(Boolean)
                          .join(" ") ||
                        "—"
                      }}
                    </p>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <span class="d-inline-flex align-items-center">
                      <i class="ti ti-calendar-check me-2"></i>Date Of Join
                    </span>
                    <p class="text-dark">{{ joinDate }}</p>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span class="d-inline-flex align-items-center">
                      <i class="ti ti-building-community me-2"></i>Company
                    </span>
                    <p class="text-dark">
                      {{
                        employee.company?.company_name || companyLabel || "—"
                      }}
                    </p>
                  </div>

                  <div class="row gx-2 mt-3 dq-profile-actions">
                    <div class="col-6">
                      <div>
                        <a
                          href="javascript:void(0);"
                          class="btn btn-dark w-100"
                          data-bs-toggle="modal"
                          data-bs-target="#edit_employee"
                          @click="openEditEmployee"
                        >
                          <i class="ti ti-edit me-1"></i>Edit Info
                        </a>
                      </div>
                    </div>
                    <div class="col-6">
                      <div>
                        <router-link
                          to="/applications/chat"
                          class="btn btn-primary w-100 disable"
                        >
                          <i class="ti ti-message-heart me-1"></i>Message
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Basic information -->
              <div class="p-3 border-bottom">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <h6>Basic information</h6>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-icon btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_employee"
                    @click="openEditEmployee"
                    ><i class="ti ti-edit"></i
                  ></a>
                </div>

                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-phone me-2"></i>Phone</span
                  >
                  <p class="text-dark">{{ employee.phone || "—" }}</p>
                </div>

                <div class="d-flex align-items-center justify-content-between">
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-calendar-repeat me-2"></i>Pay Frequency</span
                  >
                  <p class="text-dark text-end mb-0">
                    {{ employee.pay_frequency || "monthly" }}
                  </p>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-mail-check me-2"></i>Email</span
                  >
                  <a
                    href="javascript:void(0);"
                    class="text-info d-inline-flex align-items-center"
                    @click.prevent="copyEmployeeEmail"
                    :title="employee.email ? 'Copy email' : 'No email available'"
                  >
                    {{ employee.email }}
                    <i class="ti ti-copy text-dark ms-2"></i>
                  </a>
                </div>

                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-gender-male me-2"></i>Gender</span
                  >
                  <p class="text-dark text-end">{{ employee.gender || "—" }}</p>
                </div>

                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-cake me-2"></i>Birthday</span
                  >
                  <p class="text-dark text-end">{{ dob }}</p>
                </div>

                <div class="d-flex align-items-center justify-content-between">
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-map-pin-check me-2"></i>Address</span
                  >
                  <p class="text-dark text-end mb-0">
                    {{ employee.address || "—" }}
                  </p>
                </div>
              </div>

              <!-- Personal Information (triggers personal modal in details-modal) -->
              <div class="p-3 border-bottom">
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <h6>Personal Information</h6>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-icon btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#edit_personal"
                    ><i class="ti ti-edit"></i
                  ></a>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-coin me-2"></i>Salary basis</span
                  >
                  <p class="text-dark text-end mb-0">
                    {{ employee.salary_basis || "—" }}
                  </p>
                </div>

                <div class="d-flex align-items-center justify-content-between">
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-wallet me-2"></i>Payment Mode</span
                  >
                  <p class="text-dark text-end mb-0">
                    {{ employee.payment_mode || "—" }}
                  </p>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-e-passport me-2"></i>Passport No</span
                  >
                  <p class="text-dark">{{ employee.passport_no || "—" }}</p>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-gender-male me-2"></i>Nationality</span
                  >
                  <p class="text-dark text-end">
                    {{ employee.nationality || "—" }}
                  </p>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-bookmark-plus me-2"></i>Religion</span
                  >
                  <p class="text-dark text-end">
                    {{ employee.religion || "—" }}
                  </p>
                </div>
                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center"
                    ><i class="ti ti-hotel-service me-2"></i>Marital
                    status</span
                  >
                  <p class="text-dark text-end">
                    {{ employee.marital_status || "—" }}
                  </p>
                </div>

                <div
                  class="d-flex align-items-center justify-content-between mb-2"
                >
                  <span class="d-inline-flex align-items-center">
                    <i class="ti ti me-2"></i>Disability Status</span
                  >
                  <p class="text-dark text-end">
                    {{ employee.disability_status || "—" }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-between mb-2">
            <h6>Emergency Contact</h6>
            <a
              href="javascript:void(0);"
              class="btn btn-icon btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#edit_emergency"
              ><i class="ti ti-edit"></i
            ></a>
          </div>

          <div class="card">
            <div class="card-body p-0">
              <div class="p-3 border-bottom">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <span class="d-inline-flex align-items-center"
                      >Primary</span
                    >
                    <h6 class="d-flex align-items-center fw-medium mt-1">
                      {{ employee.primary_emergency_contact_name || "—" }}
                      <span class="d-inline-flex mx-1"
                        ><i class="ti ti-point-filled text-danger"></i
                      ></span>
                      {{
                        employee.primary_emergency_contact_relationship || "—"
                      }}
                    </h6>
                  </div>
                  <p class="text-dark">
                    {{ employee.primary_emergency_contact_phone || "—" }}
                  </p>
                </div>
              </div>

              <div class="p-3 border-bottom">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <span class="d-inline-flex align-items-center"
                      >Secondary</span
                    >
                    <h6 class="d-flex align-items-center fw-medium mt-1">
                      {{ employee.secondary_emergency_contact_name || "—" }}
                      <span class="d-inline-flex mx-1"
                        ><i class="ti ti-point-filled text-danger"></i
                      ></span>
                      {{
                        employee.secondary_emergency_contact_relationship || "—"
                      }}
                    </h6>
                  </div>
                  <p class="text-dark">
                    {{ employee.secondary_emergency_contact_phone || "—" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- RIGHT -->
        <div class="col-xl-8">
          <employee-onboarding-documents
            v-if="employee?.id"
            mode="hr"
            :employee-id="employee.id"
          />
          <div>
            <div class="tab-content custom-accordion-items">
              <div
                class="tab-pane active show"
                id="bottom-justified-tab1"
                role="tabpanel"
              >
                <div
                  class="accordion accordions-items-seperate"
                  id="accordionExample"
                >
                  <!-- About -->
                  <div class="accordion-item">
                    <div class="accordion-header" id="headingOne">
                      <div class="accordion-button">
                        <div class="d-flex align-items-center flex-fill">
                          <h5>About Employee</h5>
                          <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-icon ms-auto"
                            @click.prevent="openEditEmployee({ focusAbout: true })"
                            ><i class="ti ti-edit"></i
                          ></a>
                          <a
                            href="javascript:void(0);"
                            class="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderOne"
                            aria-expanded="false"
                            aria-controls="primaryBorderOne"
                          >
                            <i class="ti ti-chevron-down fs-18"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderOne"
                      class="accordion-collapse collapse show border-top"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body mt-2">
                        {{ employee.about || "—" }}
                      </div>
                    </div>
                  </div>

                  <!-- Bank Information -->
                  <div class="accordion-item">
                    <div class="accordion-header" id="headingTwo">
                      <div class="accordion-button">
                        <div class="d-flex align-items-center flex-fill">
                          <h5>Bank Information</h5>
                          <a
                            href="javascript:void(0);"
                            class="btn btn-sm btn-icon ms-auto"
                            data-bs-toggle="modal"
                            data-bs-target="#edit_bank"
                            ><i class="ti ti-edit"></i
                          ></a>
                          <a
                            href="javascript:void(0);"
                            class="d-flex align-items-center collapsed collapse-arrow"
                            data-bs-toggle="collapse"
                            data-bs-target="#primaryBorderTwo"
                            aria-expanded="false"
                            aria-controls="primaryBorderTwo"
                          >
                            <i class="ti ti-chevron-down fs-18"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderTwo"
                      class="accordion-collapse collapse border-top"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center"
                              >Bank Code</span
                            >
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.bank_code || "—" }}
                            </h6>
                          </div>
                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center"
                              >Bank Name</span
                            >
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.bank_name || "—" }}
                            </h6>
                          </div>
                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center"
                              >Bank Account No</span
                            >
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.account_number || "—" }}
                            </h6>
                          </div>
                          <!-- <div class="col-md-3">
                            <span class="d-inline-flex align-items-center">BIC/IFSC</span>
                            <h6 class="d-flex align-items-center fw-medium mt-1">{{ employee.bank_identifier_code || '—' }}</h6>
                          </div> -->
                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center"
                              >Branch</span
                            >
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.branch_location || "—" }}
                            </h6>
                          </div>

                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center"
                              >Branch Code</span
                            >
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.branch_code || "—" }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Family -->
                  <div class="accordion-item">
                    <div class="accordion-header" id="headingThree">
                      <div class="accordion-button">
                        <div
                          class="d-flex align-items-center justify-content-between flex-fill"
                        >
                          <h5>Next of Kin Information</h5>
                          <div class="d-flex">
                            <a
                              href="javascript:void(0);"
                              class="btn btn-icon btn-sm"
                              data-bs-toggle="modal"
                              data-bs-target="#edit_familyinformation"
                              ><i class="ti ti-edit"></i
                            ></a>
                            <a
                              href="javascript:void(0);"
                              class="d-flex align-items-center collapsed collapse-arrow"
                              data-bs-toggle="collapse"
                              data-bs-target="#primaryBorderThree"
                              aria-expanded="false"
                              aria-controls="primaryBorderThree"
                            >
                              <i class="ti ti-chevron-down fs-18"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="primaryBorderThree"
                      class="accordion-collapse collapse border-top"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        <div class="row">
                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center">
                              Name
                            </span>
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.family_contact_name || "—" }}
                            </h6>
                          </div>
                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center"
                              >Relationship</span
                            >
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.family_contact_relationship || "—" }}
                            </h6>
                          </div>
                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center"
                              >Phone</span
                            >
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.family_contact_phone || "—" }}
                            </h6>
                          </div>
                          <div class="col-md-3">
                            <span class="d-inline-flex align-items-center"
                              >Children</span
                            >
                            <h6
                              class="d-flex align-items-center fw-medium mt-1"
                            >
                              {{ employee.no_of_children || "—" }}
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Education + Experience (static look, dynamic text optional) -->
                  <div class="row">
                    <div class="col-md-6">
                      <div class="accordion-item">
                        <div class="row">
                          <div class="accordion-header" id="headingFour">
                            <div class="accordion-button">
                              <div
                                class="d-flex align-items-center justify-content-between flex-fill"
                              >
                                <h5>Education Details</h5>
                                <div class="d-flex">
                                  <a
                                    href="javascript:void(0);"
                                    class="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_education"
                                    ><i class="ti ti-edit"></i
                                  ></a>
                                  <a
                                    href="javascript:void(0);"
                                    class="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderFour"
                                    aria-expanded="false"
                                    aria-controls="primaryBorderFour"
                                  >
                                    <i class="ti ti-chevron-down fs-18"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Education Details (RIGHT column) -->
                          <div
                            id="primaryBorderFour"
                            class="accordion-collapse collapse border-top"
                            aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              <div
                                v-if="
                                  employee?.educations &&
                                  employee.educations.length
                                "
                              >
                                <div
                                  v-for="(edu, idx) in employee.educations"
                                  :key="idx"
                                  class="mb-3"
                                >
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <div>
                                      <span
                                        class="d-inline-flex align-items-center fw-normal"
                                        >{{ edu.institution_name || "—" }}</span
                                      >
                                      <h6
                                        class="d-flex align-items-center mt-1"
                                      >
                                        {{ edu.course || "—" }}
                                      </h6>
                                    </div>
                                    <p class="text-dark">
                                      {{ formatYear(edu.start_date) }} -
                                      {{
                                        formatYear(edu.end_date) ||
                                        (edu.graduated ? "Graduated" : "—")
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div v-else>
                                <!-- fallback to legacy single fields -->
                                <div
                                  class="mb-3"
                                  v-if="
                                    employee?.institution_name ||
                                    employee?.course
                                  "
                                >
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <div>
                                      <span
                                        class="d-inline-flex align-items-center fw-normal"
                                        >{{
                                          employee.institution_name || "—"
                                        }}</span
                                      >
                                      <h6
                                        class="d-flex align-items-center mt-1"
                                      >
                                        {{ employee.course || "—" }}
                                      </h6>
                                    </div>
                                    <p class="text-dark">
                                      {{
                                        shortPeriod(
                                          employee.education_start_date,
                                          employee.education_end_date
                                        )
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="accordion-item">
                        <div class="row">
                          <div class="accordion-header" id="headingFive">
                            <div class="accordion-button collapsed">
                              <div
                                class="d-flex align-items-center justify-content-between flex-fill"
                              >
                                <h5>Experience</h5>
                                <div class="d-flex">
                                  <a
                                    href="javascript:void(0);"
                                    class="btn btn-icon btn-sm"
                                    data-bs-toggle="modal"
                                    data-bs-target="#edit_experience"
                                    ><i class="ti ti-edit"></i
                                  ></a>
                                  <a
                                    href="javascript:void(0);"
                                    class="d-flex align-items-center collapsed collapse-arrow"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#primaryBorderFive"
                                    aria-expanded="false"
                                    aria-controls="primaryBorderFive"
                                  >
                                    <i class="ti ti-chevron-down fs-18"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- Experience (RIGHT column) -->
                          <div
                            id="primaryBorderFive"
                            class="accordion-collapse collapse border-top"
                            aria-labelledby="headingFive"
                            data-bs-parent="#accordionExample"
                          >
                            <div class="accordion-body">
                              <div
                                v-if="
                                  employee?.experiences &&
                                  employee.experiences.length
                                "
                              >
                                <div
                                  v-for="(exp, idx) in employee.experiences"
                                  :key="idx"
                                  class="mb-3"
                                >
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <div>
                                      <h6
                                        class="d-inline-flex align-items-center fw-medium"
                                      >
                                        {{ exp.company || "—" }}
                                      </h6>
                                      <span
                                        class="d-flex align-items-center badge bg-secondary-transparent mt-1"
                                      >
                                        <i class="ti ti-point-filled me-1"></i
                                        >{{ exp.designation || "—" }}
                                      </span>
                                    </div>
                                    <p class="text-dark">
                                      {{
                                        shortPeriod(
                                          exp.start_date,
                                          exp.end_date,
                                          exp.currently_working
                                        )
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <div v-else>
                                <!-- fallback to legacy single experience -->
                                <div class="mb-3">
                                  <div
                                    class="d-flex align-items-center justify-content-between"
                                  >
                                    <div>
                                      <h6
                                        class="d-inline-flex align-items-center fw-medium"
                                      >
                                        {{ employee.previous_employer || "—" }}
                                      </h6>
                                      <span
                                        class="d-flex align-items-center badge bg-secondary-transparent mt-1"
                                      >
                                        <i class="ti ti-point-filled me-1"></i
                                        >{{ employee.job_designation || "—" }}
                                      </span>
                                    </div>
                                    <p class="text-dark">
                                      {{ experiencePeriod }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Projects / Assets tabs  -->
                  <!-- =========================
     Projects / Assets (UPGRADED)
========================== -->
                  <div class="card dq-tabs-card">
                    <!-- Header -->
                    <div class="dq-tabs-head">
                      <div
                        class="d-flex align-items-start justify-content-between gap-2"
                      >
                        <div class="dq-tabs-title">
                          <div class="d-flex align-items-center gap-2">
                            <span class="dq-tabs-icon">
                              <i class="ti ti-briefcase"></i>
                            </span>
                            <div class="min-w-0">
                              <h5 class="mb-0 text-truncate">
                                Work & Resources
                              </h5>
                              <small class="text-muted d-block text-truncate">
                                Projects assigned to this employee + company
                                assets issued
                              </small>
                            </div>
                          </div>
                        </div>

                        <div
                          class="d-flex align-items-center gap-2 flex-wrap justify-content-end"
                        >
                          <span class="dq-chip">
                            <i class="ti ti-folders me-1"></i>
                            {{ employeeProjects.length }} Projects
                          </span>
                          <span class="dq-chip">
                            <i class="ti ti-device-laptop me-1"></i>
                            {{ assetTotalCount }} Assets
                          </span>

                          <router-link
                            to="/projects/projects-list"
                            class="btn btn-primary btn-sm dq-btn"
                          >
                            <i class="ti ti-folder me-1"></i>All Projects
                          </router-link>
                        </div>
                      </div>

                      <!-- Tabs -->
                      <div class="dq-tabs-switch mt-3">
                        <button
                          class="dq-tab"
                          :class="{ active: activePaTab === 'projects' }"
                          type="button"
                          @click="activePaTab = 'projects'"
                        >
                          <i class="ti ti-briefcase me-2"></i>
                          <span>Projects</span>
                          <span class="dq-tab-count">{{
                            employeeProjects.length
                          }}</span>
                        </button>

                        <button
                          class="dq-tab"
                          :class="{ active: activePaTab === 'assets' }"
                          type="button"
                          @click="activePaTab = 'assets'"
                        >
                          <i class="ti ti-device-laptop me-2"></i>
                          <span>Assets</span>
                          <span class="dq-tab-count">{{
                            assetTotalCount
                          }}</span>
                        </button>
                      </div>
                    </div>

                    <!-- Body -->
                    <div class="card-body dq-tabs-body">
                      <!-- =======================
         PROJECTS TAB
    ======================== -->
                      <div v-show="activePaTab === 'projects'">
                        <!-- Toolbar -->
                        <div class="dq-toolbar">
                          <div class="dq-toolbar-left">
                            <div class="dq-input">
                              <i class="ti ti-search"></i>
                              <input
                                v-model="projectFilters.q"
                                type="text"
                                style="min-width: 300px"
                                class="form-control"
                                placeholder="Search projects by name or code…"
                                @input="debouncedReloadProjects()"
                              />
                            </div>

                            <select
                              v-model="projectFilters.status"
                              class="form-select dq-select"
                              @change="reloadProjects()"
                            >
                              <option value="">All Status</option>
                              <option value="Active">Active</option>
                              <option value="Inactive">Inactive</option>
                            </select>

                            <select
                              v-model="projectFilters.priority"
                              class="form-select dq-select"
                              @change="reloadProjects()"
                            >
                              <option value="">All Priority</option>
                              <option value="High">High</option>
                              <option value="Medium">Medium</option>
                              <option value="Low">Low</option>
                            </select>

                            <select
                              v-model="projectFilters.sort"
                              class="form-select dq-select"
                              @change="reloadProjects()"
                            >
                              <option value="recent">Recent</option>
                              <option value="asc">Name (A → Z)</option>
                              <option value="desc">Name (Z → A)</option>
                              <option value="oldest">Oldest</option>
                            </select>
                          </div>

                          <div class="dq-toolbar-right">
                            <button
                              class="btn btn-outline-secondary btn-sm dq-btn"
                              type="button"
                              @click="resetProjectFilters()"
                              :disabled="projectsLoading"
                            >
                              <i class="ti ti-refresh me-1"></i>Reset
                            </button>
                          </div>
                        </div>

                        <!-- States -->
                        <div
                          v-if="projectsLoading"
                          class="dq-state dq-state-info"
                        >
                          <i class="ti ti-loader-2 me-2 dq-spin"></i> Loading
                          projects…
                        </div>

                        <div
                          v-else-if="!employeeProjects.length"
                          class="dq-empty"
                        >
                          <div class="dq-empty-icon">
                            <i class="ti ti-briefcase"></i>
                          </div>
                          <h6 class="mb-1">No projects found</h6>
                          <!-- <p class="text-muted mb-0">
                            This employee is not assigned to any project — or
                            your filters returned nothing.
                          </p> -->
                        </div>

                        <!-- Projects Grid -->
                        <div v-else class="row g-3">
                          <div
                            v-for="p in employeeProjects"
                            :key="p.id"
                            class="col-lg-6 d-flex"
                          >
                            <div class="card dq-item flex-fill">
                              <div class="card-body">
                                <!-- Top -->
                                <div
                                  class="d-flex align-items-start justify-content-between gap-2 mb-3"
                                >
                                  <div
                                    class="d-flex align-items-center gap-2 min-w-0"
                                  >
                                    <span class="dq-item-icon">
                                      <i class="ti ti-folders"></i>
                                    </span>

                                    <div class="min-w-0">
                                      <h6 class="mb-1 text-truncate">
                                        <router-link
                                          class="dq-link"
                                          :to="{
                                            path: '/projects/projects-details',
                                            query: { id: p.id },
                                          }"
                                        >
                                          {{ p.name }}
                                        </router-link>
                                      </h6>

                                      <div
                                        class="d-flex align-items-center flex-wrap gap-2"
                                      >
                                        <span class="dq-pill dq-pill-dark">
                                          {{ p.project_code || "—" }}
                                        </span>

                                        <span
                                          class="dq-pill"
                                          :class="
                                            p.status === 'Active'
                                              ? 'dq-pill-success'
                                              : 'dq-pill-muted'
                                          "
                                        >
                                          <i class="ti ti-point-filled me-1"></i
                                          >{{ p.status || "—" }}
                                        </span>

                                        <span
                                          class="dq-pill"
                                          :class="priorityPillClass(p.priority)"
                                        >
                                          <i class="ti ti-flag-3 me-1"></i
                                          >{{ p.priority || "—" }}
                                        </span>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="dropdown">
                                    <a
                                      href="javascript:void(0);"
                                      class="dq-more"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="ti ti-dots-vertical"></i>
                                    </a>
                                    <ul
                                      class="dropdown-menu dropdown-menu-end p-2"
                                    >
                                      <li>
                                        <router-link
                                          class="dropdown-item rounded-1"
                                          :to="{
                                            path: '/projects/projects-details',
                                            query: { id: p.id },
                                          }"
                                        >
                                          <i class="ti ti-eye me-2"></i>View
                                          Details
                                        </router-link>
                                      </li>
                                      <li>
                                        <router-link
                                          class="dropdown-item rounded-1"
                                          :to="{
                                            path: '/projects/tasks',
                                            query: { project_id: p.id },
                                          }"
                                        >
                                          <i class="ti ti-checklist me-2"></i
                                          >View Tasks
                                        </router-link>
                                      </li>
                                    </ul>
                                  </div>
                                </div>

                                <!-- Meta -->
                                <div class="dq-meta">
                                  <div class="dq-meta-item">
                                    <span class="dq-meta-label">Deadline</span>
                                    <span class="dq-meta-value">
                                      {{
                                        p.deadline
                                          ? prettyDate(p.deadline)
                                          : "—"
                                      }}
                                    </span>
                                  </div>

                                  <div class="dq-meta-item">
                                    <span class="dq-meta-label"
                                      >Project Lead</span
                                    >
                                    <span class="dq-lead">
                                      <span class="dq-lead-avatar">
                                        <img
                                          v-if="p.leader_avatar"
                                          :src="p.leader_avatar"
                                          alt="Lead"
                                        />
                                        <i
                                          v-else
                                          class="ti ti-user text-muted"
                                        ></i>
                                      </span>
                                      <span
                                        class="dq-meta-value text-truncate"
                                        >{{ p.leader_name || "—" }}</span
                                      >
                                    </span>
                                  </div>
                                </div>

                                <!-- Progress -->
                                <div class="mt-3">
                                  <div
                                    class="d-flex align-items-center justify-content-between mb-2"
                                  >
                                    <span class="text-muted">Tasks</span>
                                    <span class="fw-semibold">
                                      {{ p.completed_tasks ?? 0 }}/{{
                                        p.total_tasks ?? 0
                                      }}
                                      <span class="text-muted ms-1"
                                        >({{ projectProgress(p) }}%)</span
                                      >
                                    </span>
                                  </div>

                                  <div class="progress dq-progress">
                                    <div
                                      class="progress-bar"
                                      role="progressbar"
                                      :style="{
                                        width: projectProgress(p) + '%',
                                      }"
                                      :aria-valuenow="projectProgress(p)"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                                    ></div>
                                  </div>

                                  <div
                                    class="d-flex align-items-center justify-content-between mt-2"
                                  >
                                    <div
                                      class="avatar-list-stacked avatar-group-sm"
                                    >
                                      <span
                                        v-for="(av, idx) in (
                                          p.team_avatars || []
                                        ).slice(0, 3)"
                                        :key="idx"
                                        class="avatar avatar-xs rounded-circle border overflow-hidden"
                                      >
                                        <img
                                          v-if="av"
                                          :src="av"
                                          class="img-fluid"
                                          alt="Member"
                                        />
                                        <span
                                          v-else
                                          class="d-flex align-items-center justify-content-center h-100 w-100 bg-light"
                                        >
                                          <i class="ti ti-user text-muted"></i>
                                        </span>
                                      </span>

                                      <span
                                        v-if="p.extra_team_count"
                                        class="avatar avatar-xs rounded-circle border bg-light d-flex align-items-center justify-content-center"
                                        :title="`${p.extra_team_count} more`"
                                      >
                                        <small class="text-muted fw-semibold"
                                          >+{{ p.extra_team_count }}</small
                                        >
                                      </span>
                                    </div>

                                    <router-link
                                      :to="{
                                        path: '/projects/tasks',
                                        query: { project_id: p.id },
                                      }"
                                      class="btn btn-outline-secondary btn-sm dq-btn"
                                    >
                                      <i class="ti ti-checklist me-1"></i>Open
                                      Tasks
                                    </router-link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- /grid -->
                      </div>

                      <!-- =======================
         ASSETS TAB
    ======================== -->
                      <div v-show="activePaTab === 'assets'">
                        <!-- Toolbar -->
                        <div class="dq-toolbar">
                          <div class="dq-toolbar-left">
                            <span class="dq-chip dq-chip-primary">
                              <i class="ti ti-device-laptop me-1"></i>Assigned
                              Assets
                            </span>
                            <small class="text-muted">
                              {{ assetTotalCount }} total
                            </small>

                            <div class="dq-input dq-input-wide">
                              <i class="ti ti-search"></i>
                              <input
                                v-model="assetStore.filters.search"
                                type="text"
                                class="form-control"
                                placeholder="Search by name, asset tag, serial…"
                                @keyup.enter="onAssetSearch"
                              />
                            </div>

                            <select
                              v-model="assetStore.filters.status"
                              class="form-select dq-select"
                              @change="onAssetSearch"
                            >
                              <option value="">All Status</option>
                              <option value="Active">Active</option>
                              <option value="Inactive">Inactive</option>
                              <option value="Maintenance">Maintenance</option>
                              <option value="Disposed">Disposed</option>
                            </select>
                          </div>

                          <div class="dq-toolbar-right">
                            <button
                              class="btn btn-outline-secondary btn-sm dq-btn"
                              type="button"
                              @click="clearAssetFilters"
                            >
                              <i class="ti ti-rotate-2 me-1"></i>Reset
                            </button>

                            <button
                              class="btn btn-dark btn-sm dq-btn"
                              type="button"
                              @click="loadAssets()"
                            >
                              <i class="ti ti-refresh me-1"></i>Refresh
                            </button>
                          </div>
                        </div>

                        <!-- States -->
                        <div
                          v-if="assetStore.loading"
                          class="dq-state dq-state-info"
                        >
                          <i class="ti ti-loader-2 me-2 dq-spin"></i> Loading
                          assets…
                        </div>

                        <div
                          v-else-if="assetStore.error"
                          class="dq-state dq-state-danger"
                        >
                          <i class="ti ti-alert-triangle me-2"></i>
                          {{ assetStore.error }}
                        </div>

                        <div
                          v-else-if="!assetStore.items.length"
                          class="dq-empty"
                        >
                          <div class="dq-empty-icon">
                            <i class="ti ti-box"></i>
                          </div>
                          <h6 class="mb-1">No assets assigned</h6>
                          <!-- <p class="text-muted mb-0">
                            This employee currently has no issued assets.
                          </p> -->
                        </div>

                        <!-- Assets List -->
                        <div v-else class="dq-list">
                          <div
                            v-for="a in assetStore.items"
                            :key="a.id"
                            class="dq-list-item"
                          >
                            <div class="dq-list-left">
                              <span class="dq-asset-avatar">
                                {{ (a.name || "A").slice(0, 1).toUpperCase() }}
                              </span>

                              <div class="min-w-0">
                                <div
                                  class="d-flex align-items-center gap-2 min-w-0"
                                >
                                  <h6 class="mb-0 text-truncate">
                                    {{ a.name }}
                                  </h6>
                                  <span
                                    class="dq-pill"
                                    :class="statusPillClass(a.status)"
                                  >
                                    {{ a.status || "—" }}
                                  </span>
                                </div>

                                <div class="dq-submeta">
                                  <span
                                    v-if="a.asset_tag"
                                    class="dq-submeta-strong"
                                    >{{ a.asset_tag }}</span
                                  >

                                  <span v-if="a.serial_number">
                                    <i class="ti ti-point-filled mx-1"></i>
                                    Serial: {{ a.serial_number }}
                                  </span>

                                  <span v-if="a.purchase_date">
                                    <i class="ti ti-point-filled mx-1"></i>
                                    Purchased:
                                    {{ fmtDateShort(a.purchase_date) }}
                                  </span>

                                  <span v-if="a.warranty_end_date">
                                    <i class="ti ti-point-filled mx-1"></i>
                                    Warranty:
                                    {{ fmtDateShort(a.warranty_end_date) }}
                                  </span>
                                </div>

                                <div class="dq-badges">
                                  <span
                                    class="dq-pill dq-pill-dark"
                                    v-if="a.category?.name"
                                  >
                                    <i class="ti ti-category me-1"></i
                                    >{{ a.category.name }}
                                  </span>

                                  <span
                                    class="dq-pill dq-pill-muted"
                                    v-if="a.manufacturer || a.model"
                                  >
                                    <i class="ti ti-settings me-1"></i
                                    >{{
                                      [a.manufacturer, a.model]
                                        .filter(Boolean)
                                        .join(" ")
                                    }}
                                  </span>

                                  <span
                                    class="dq-pill dq-pill-info"
                                    v-if="a.location"
                                  >
                                    <i class="ti ti-map-pin me-1"></i
                                    >{{ a.location }}
                                  </span>
                                </div>
                              </div>
                            </div>

                            <div class="dq-list-right">
                              <div class="dropdown">
                                <button
                                  class="btn btn-outline-dark btn-sm dq-btn"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  Actions
                                  <i class="ti ti-chevron-down ms-1"></i>
                                </button>

                                <ul class="dropdown-menu dropdown-menu-end p-2">
                                  <li>
                                    <a
                                      href="javascript:void(0);"
                                      class="dropdown-item rounded-1"
                                      data-bs-toggle="modal"
                                      data-bs-target="#asset_info"
                                      @click="openAssetInfo(a)"
                                    >
                                      <i class="ti ti-info-circle me-2"></i>View
                                      Info
                                    </a>
                                  </li>

                                  <li>
                                    <a
                                      href="javascript:void(0);"
                                      class="dropdown-item rounded-1"
                                      data-bs-toggle="modal"
                                      data-bs-target="#refuse_msg"
                                      @click="openAssetInfo(a)"
                                    >
                                      <i class="ti ti-alert-triangle me-2"></i
                                      >Raise Issue
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <!-- Pagination -->
                          <div class="dq-pagination mt-3">
                            <small class="text-muted">
                              Page {{ assetStore.pagination.current_page || 1 }}
                              <span v-if="assetStore.pagination.total">
                                • {{ assetStore.pagination.total }} records
                              </span>
                            </small>

                            <div class="btn-group">
                              <button
                                class="btn btn-outline-secondary btn-sm dq-btn"
                                :disabled="!assetHasPrev || assetStore.loading"
                                @click="
                                  goAssetPage(
                                    (assetStore.pagination.current_page || 1) -
                                      1
                                  )
                                "
                              >
                                <i class="ti ti-chevron-left"></i>
                              </button>
                              <button
                                class="btn btn-outline-secondary btn-sm dq-btn"
                                :disabled="!assetHasNext || assetStore.loading"
                                @click="
                                  goAssetPage(
                                    (assetStore.pagination.current_page || 1) +
                                      1
                                  )
                                "
                              >
                                <i class="ti ti-chevron-right"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- /list -->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /accordion -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="javascript:void(0);" class="text-primary"
          >DoneQuick Technological World</a
        >
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- All edit modals live here (from employee-details-modal) -->
  <EmployeeDetailsModal
    ref="detailsModalRef"
    :employee="employee"
    :nextEmployeeId="nextEmployeeId"
    :selectedAsset="selectedAsset"
    @saved="refreshEmployee"
  />
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, nextTick, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useEmployeeStore } from "@/stores/employeeStore";
import { storeToRefs } from "pinia";
import EmployeeDetailsModal from "@/components/modal/employee-details-modal.vue";
import EmployeeOnboardingDocuments from "@/components/hrm/employee-onboarding-documents.vue";
import { useCompanyStore } from "@/stores/companyStore";
import { useProjectStore } from "@/stores/projectStore";
import { useAssetStore } from "@/stores/assetStore";
import { toast } from "@/utils/toast";

const route = useRoute();
const router = useRouter();
const employeeStore = useEmployeeStore();
const companyStore = useCompanyStore();
const projectStore = useProjectStore();
const assetStore = useAssetStore();
const { employees } = storeToRefs(employeeStore);

const projectFilters = ref({
  q: "",
  status: "",
  priority: "",
  sort: "recent",
});

const selectedAsset = ref(null);

// UI tab state (no Bootstrap tabs needed)
const activePaTab = ref("projects");

// Assets total count (prefers pagination.total if present)
const assetTotalCount = computed(() => {
  const p = assetStore.pagination || {};
  return Number(p.total || 0) || assetStore.items?.length || 0;
});

// ✅ Safer default filters (prevents "Cannot set properties of undefined (setting 'page')")
const DEFAULT_ASSET_FILTERS = {
  search: "",
  category_id: "",
  assigned_to_id: "",
  status: "",
  purchased_from: "",
  purchased_to: "",
  per_page: 25,
  page: 1,
};

function ensureAssetFilters() {
  if (!assetStore.filters || typeof assetStore.filters !== "object") {
    assetStore.filters = { ...DEFAULT_ASSET_FILTERS };
  }
  if (assetStore.filters.page == null) assetStore.filters.page = 1;
  if (assetStore.filters.per_page == null) assetStore.filters.per_page = 25;
}

const idParam = computed(() => route.params.id || route.query.id || null);

const loading = ref(true);
const employee = ref(null);

const { activeCompanyId } = storeToRefs(companyStore);

// async function loadEmployee() {
//   loading.value = true;
//   const id = idParam.value;
//   if (!id) {
//     loading.value = false;
//     employee.value = null;
//     return;
//   }
//   try {
//     // Prefer store action fetch by id if available
//     const emp =
//       (await employeeStore.fetchEmployee?.(id)) ||
//       employees.value.find((e) => String(e.id) === String(id)) ||
//       null;
//     employee.value = emp;
//   } catch (e) {
//     employee.value = null;
//   } finally {
//     loading.value = false;
//   }
// }

async function loadEmployee() {
  loading.value = true;
  const id = idParam.value;
  if (!id) {
    loading.value = false;
    employee.value = null;
    return;
  }

  try {
    await employeeStore.fetchEmployee(id); // just fetch
    employee.value = employeeStore.employee; // then read it
    await nextTick();
    window.scrollTo({ top: 0, behavior: "auto" });
  } catch (e) {
    employee.value = null;
  } finally {
    loading.value = false;
  }
}

function cleanupPageScrollState() {
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
  document
    .querySelectorAll(".modal-backdrop, .offcanvas-backdrop")
    .forEach((node) => node.remove());
}

function formatYear(d) {
  if (!d) return "";
  const dt = new Date(d);
  return isNaN(dt) ? "" : String(dt.getFullYear());
}
function shortPeriod(start, end, current = false) {
  const s = start ? new Date(start) : null;
  const e = end ? new Date(end) : null;
  const sY = s ? s.toLocaleDateString() : null;
  const eY = e ? e.toLocaleDateString() : current ? "Present" : null;
  return sY ? `${sY} - ${eY || "—"}` : "—";
}

onMounted(async () => {
  cleanupPageScrollState();
  await loadEmployee();
});
onBeforeUnmount(() => {
  cleanupPageScrollState();
});
watch(idParam, async () => {
  cleanupPageScrollState();
  await loadEmployee();
});

watch(
  () => employee.value?.id,
  (id) => {
    if (id) reloadProjects();
  }
);

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function copyEmployeeEmail() {
  const email = String(employee.value?.email || "").trim();
  if (!email) {
    toast("No email available to copy.", "error");
    return;
  }

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(email);
    } else {
      const input = document.createElement("input");
      input.value = email;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      input.remove();
    }
    toast("Email copied to clipboard.");
  } catch (error) {
    toast("Failed to copy email.", "error");
  }
}

const fullName = computed(() =>
  employee.value
    ? `${employee.value.first_name || ""} ${
        employee.value.last_name || ""
      }`.trim()
    : ""
);

const joinDate = computed(() => {
  const d = employee.value?.company_doj
    ? new Date(employee.value.company_doj)
    : null;
  return d ? d.toLocaleDateString() : "—";
});
const dob = computed(() => {
  const d = employee.value?.dob ? new Date(employee.value.dob) : null;
  return d ? d.toLocaleDateString() : "—";
});
// const experienceLabel = computed(() => {
//   // placeholder “years of experience” (if you later track it, map here)
//   return employee.value?.years_experience
//     ? `${employee.value.years_experience}+ years of Experience`
//     : "";
// });

const experienceLabel = computed(() => {
  const e = employee.value;
  if (!e) return "";

  const toD = (v) => (v ? new Date(v) : null);
  const today = new Date();

  // 1) Collect intervals from the new JSON array (fallback to legacy single fields)
  const intervals = [];
  if (Array.isArray(e.experiences) && e.experiences.length) {
    e.experiences.forEach((exp) => {
      const s = toD(exp.start_date);
      const end = toD(exp.end_date) || (exp.currently_working ? today : null);
      if (s && end && end >= s) intervals.push([s, end]);
    });
  } else {
    const s = toD(e.employment_start_date);
    const end =
      toD(e.employment_end_date) || (e.currently_working ? today : null);
    if (s && end && end >= s) intervals.push([s, end]);
  }

  if (!intervals.length) return "";

  // 2) Merge overlaps so the same months aren’t double-counted
  intervals.sort((a, b) => a[0] - b[0]);
  const merged = [];
  for (const [s, e2] of intervals) {
    if (!merged.length || s > merged[merged.length - 1][1]) {
      merged.push([s, e2]);
    } else if (e2 > merged[merged.length - 1][1]) {
      merged[merged.length - 1][1] = e2;
    }
  }

  // 3) Sum months across merged intervals
  const monthsBetween = (s, e2) => {
    let m =
      (e2.getFullYear() - s.getFullYear()) * 12 +
      (e2.getMonth() - s.getMonth());
    if (e2.getDate() < s.getDate()) m -= 1; // day adjustment
    return Math.max(0, m);
  };
  const totalMonths = merged.reduce(
    (acc, [s, e2]) => acc + monthsBetween(s, e2),
    0
  );
  if (totalMonths <= 0) return "";

  // 4) Format label
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  const parts = [];
  if (years) parts.push(`${years} yr${years > 1 ? "s" : ""}`);
  if (months) parts.push(`${months} mo${months > 1 ? "s" : ""}`);
  return `${parts.join(" ")} of Experience`;
});

const companyTenureLabel = computed(() => {
  const doj = employee.value?.company_doj
    ? new Date(employee.value.company_doj)
    : null;
  if (!doj) return "";
  const today = new Date();
  let m =
    (today.getFullYear() - doj.getFullYear()) * 12 +
    (today.getMonth() - doj.getMonth());
  if (today.getDate() < doj.getDate()) m -= 1;
  const y = Math.floor(m / 12),
    mo = m % 12;
  const parts = [];
  if (y) parts.push(`${y} yr${y > 1 ? "s" : ""}`);
  if (mo) parts.push(`${mo} mo${mo > 1 ? "s" : ""}`);
  return parts.length ? `${parts.join(" ")} at Company` : "";
});

const experiencePeriod = computed(() => {
  const s = employee.value?.employment_start_date
    ? new Date(employee.value.employment_start_date).toLocaleDateString()
    : null;
  const e = employee.value?.employment_end_date
    ? new Date(employee.value.employment_end_date).toLocaleDateString()
    : "Present";
  return s ? `${s} - ${e}` : "—";
});

const detailsModalRef = ref(null);
async function openEditEmployee(opts = {}) {
  // Ignore native click Event objects from @click="openEditEmployee"
  const focusAbout =
    opts &&
    typeof opts === "object" &&
    !(opts instanceof Event) &&
    !!opts.focusAbout;

  if (focusAbout) {
    // Control open order so the About flag is set before the modal shows.
    await detailsModalRef.value?.openEditEmployeeModal?.({ focusAbout: true });
    return;
  }

  detailsModalRef.value?.prepareOpen?.({ focusAbout: false });
}

const nextEmployeeId = computed(() => {
  // matches logic from list/grid
  const list = employees.value || [];
  if (!list.length) return "EMP-0001";
  const nums = list
    .map((e) => e.employee_id)
    .filter(Boolean)
    .map((id) => parseInt(String(id).replace(/[^\d]/g, ""), 10));
  const next = Math.max(...nums, 0) + 1;
  return `EMP-${String(next).padStart(4, "0")}`;
});

async function refreshEmployee(updated) {
  // Re-fetch and stay on page; updated is optional payload from modal
  await loadEmployee();
  if (!employee.value) {
    // if just created, navigate here
    const newId = updated?.id || updated?.employee?.id;
    if (newId)
      router.replace({
        path: "/employee/employee-details",
        query: { id: newId },
      });
  }
}

const placeholderAvatar = new URL(
  "@/assets/img/users/user-13.jpg",
  import.meta.url
).href;

const companyLabel = computed(() => {
  const c = companyStore.companies.find((c) => c.id === activeCompanyId.value);
  return c ? c.company_name : "";
});

const projectsLoading = computed(() => projectStore.loading);

// employee-based projects (from store list result)
const employeeProjects = computed(() => projectStore.items || []);

let projectSearchTmr = null;
function debouncedReloadProjects() {
  clearTimeout(projectSearchTmr);
  projectSearchTmr = setTimeout(() => reloadProjects(), 350);
}

function resetProjectFilters() {
  projectFilters.value = { q: "", status: "", priority: "", sort: "recent" };
  reloadProjects();
}

function prettyDate(d) {
  if (!d) return "—";
  const dt = new Date(d);
  if (isNaN(dt)) return String(d);
  return dt.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function projectProgress(p) {
  const total = Number(p?.total_tasks ?? 0);
  const done = Number(p?.completed_tasks ?? 0);
  if (!total) return 0;
  return Math.max(0, Math.min(100, Math.round((done / total) * 100)));
}

async function reloadProjects() {
  if (!employee.value?.id) return;

  await projectStore.list({
    // 🔑 this is why backend change was needed
    employee_id: employee.value.id,

    // we want all for this tab
    paginate: false,

    // filters
    q: projectFilters.value.q || "",
    status: projectFilters.value.status || "",
    priority: projectFilters.value.priority || "",
    sort: projectFilters.value.sort || "recent",
  });
}

//Asset related to employee

async function loadAssets(extra = {}) {
  ensureAssetFilters();

  const aid = assigneeId.value;
  if (!aid) return;

  assetStore.filters = {
    ...DEFAULT_ASSET_FILTERS,
    ...assetStore.filters,
    assigned_to_id: aid,
    ...extra,
  };

  await assetStore.fetchAll();
}

function onAssetSearch() {
  ensureAssetFilters();
  assetStore.filters.page = 1;
  loadAssets();
}

function clearAssetFilters() {
  ensureAssetFilters();
  const keepAssigned = assetStore.filters.assigned_to_id;
  assetStore.filters = {
    ...DEFAULT_ASSET_FILTERS,
    assigned_to_id: keepAssigned,
  };
  loadAssets();
}

function goAssetPage(page) {
  ensureAssetFilters();
  if (page < 1) return;
  assetStore.filters.page = page;
  loadAssets();
}

// ✅ pagination helpers (your previous .value usage would break)
const assetHasPrev = computed(
  () => (assetStore.pagination?.current_page || 1) > 1
);
const assetHasNext = computed(() => {
  const total = Number(assetStore.pagination?.total || 0);
  const per = Number(assetStore.pagination?.per_page || 0);
  const cur = Number(assetStore.pagination?.current_page || 1);
  if (!total || !per) return false;
  return cur * per < total;
});

// Replace your existing statusBadgeClass for assets with a pill class (UI)
function statusPillClass(status) {
  const s = String(status || "").toLowerCase();
  if (s === "active") return "dq-pill-success";
  if (s === "inactive") return "dq-pill-muted";
  if (s === "maintenance") return "dq-pill-warning";
  if (s === "disposed") return "dq-pill-danger";
  return "dq-pill-muted";
}

// Replace your existing priorityBadgeClass with pill classes (UI)
function priorityPillClass(priority) {
  if (priority === "High") return "dq-pill-danger";
  if (priority === "Low") return "dq-pill-info";
  return "dq-pill-warning";
}

function priorityBadgeClass(priority) {
  if (priority === "High") return "badge-soft-danger";
  if (priority === "Low") return "badge-soft-info";
  return "badge-soft-warning"; // Medium/default
}

// Try best possible mapping for assigned_to_id (depends on your DB design)
const assigneeId = computed(() => {
  const e = employee.value;
  if (!e) return null;
  // Most common: assets.assigned_to_id references users.id
  return e?.user?.id ?? e?.user_id ?? null;
});

function fmtDateShort(d) {
  if (!d) return "—";
  const dt = new Date(d);
  return isNaN(dt) ? "—" : dt.toLocaleDateString();
}

function statusBadgeClass(status) {
  const s = String(status || "").toLowerCase();
  if (s === "active") return "badge bg-success-transparent";
  if (s === "inactive") return "badge bg-secondary-transparent";
  if (s === "maintenance") return "badge bg-warning-transparent";
  if (s === "disposed") return "badge bg-danger-transparent";
  return "badge bg-light text-dark";
}

// When employee changes, reload assets for that employee
watch(
  assigneeId,
  (v) => {
    if (!v) return;
    assetStore.filters.page = 1;
    loadAssets({ assigned_to_id: v });
  },
  { immediate: true }
);

function openAssetInfo(assetRow) {
  selectedAsset.value = assetRow;
  // Bootstrap will open the modal via data-bs-toggle attr in template
}
</script>

<style scoped>
.disable {
  pointer-events: none;
  opacity: 0.6;
}

/* =========================
   DQ Tabs Card
========================= */
.dq-tabs-card {
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.dq-tabs-head {
  padding: 16px 16px 0 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: linear-gradient(180deg, rgba(13, 110, 253, 0.05), transparent);
}

.dq-tabs-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(13, 110, 253, 0.12);
  color: #0d6efd;
  flex: 0 0 auto;
}

.dq-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border-radius: 999px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.06);
  white-space: nowrap;
}

.dq-chip-primary {
  background: rgba(13, 110, 253, 0.1);
  border-color: rgba(13, 110, 253, 0.18);
  color: #0d6efd;
}

.dq-tabs-switch {
  display: flex;
  gap: 8px;
  padding-bottom: 12px;
  flex-wrap: wrap;
}

.dq-tab {
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: #fff;
  padding: 10px 12px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  transition: 0.15s ease;
}

.dq-tab:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
}

.dq-tab.active {
  border-color: rgba(13, 110, 253, 0.35);
  box-shadow: 0 10px 22px rgba(13, 110, 253, 0.14);
}

.dq-tab-count {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(13, 110, 253, 0.12);
  color: #0d6efd;
  border: 1px solid rgba(13, 110, 253, 0.18);
}

.dq-tabs-body {
  padding-top: 14px;
}

/* =========================
   Toolbar
========================= */
.dq-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0 14px 0;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.dq-toolbar-left,
.dq-toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.dq-input {
  position: relative;
  min-width: 240px;
}

.dq-input-wide {
  min-width: 320px;
}

.dq-input > i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(0, 0, 0, 0.5);
}

.dq-input .form-control {
  padding-left: 36px;
  border-radius: 12px;
}

.dq-select {
  min-width: 160px;
  border-radius: 12px;
}

.dq-btn {
  border-radius: 12px;
}

/* =========================
   States / Empty
========================= */
.dq-state {
  padding: 12px 14px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  font-weight: 600;
}

.dq-state-info {
  background: rgba(13, 110, 253, 0.08);
  border: 1px solid rgba(13, 110, 253, 0.18);
  color: #0d6efd;
}

.dq-state-danger {
  background: rgba(220, 53, 69, 0.08);
  border: 1px solid rgba(220, 53, 69, 0.18);
  color: #dc3545;
}

.dq-empty {
  padding: 28px 14px;
  text-align: center;
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.02);
}

.dq-empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.06);
  margin-bottom: 10px;
}

/* =========================
   Project Cards
========================= */
.dq-item {
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: 0.15s ease;
}

.dq-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.08);
}

.dq-item-icon {
  width: 36px;
  height: 36px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(13, 110, 253, 0.1);
  color: #0d6efd;
  flex: 0 0 auto;
}

.dq-more {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
}

.dq-link {
  text-decoration: none;
}

.dq-meta {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.dq-meta-item {
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.05);
  min-width: 0;
}

.dq-meta-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  display: block;
  margin-bottom: 2px;
}

.dq-meta-value {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.8);
}

.dq-lead {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.dq-lead-avatar {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  flex: 0 0 auto;
}

.dq-lead-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dq-progress {
  height: 8px;
  border-radius: 999px;
  overflow: hidden;
}

/* =========================
   Pills
========================= */
.dq-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 999px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(0, 0, 0, 0.03);
  font-weight: 600;
}

.dq-pill-dark {
  background: rgba(0, 0, 0, 0.06);
  border-color: rgba(0, 0, 0, 0.1);
}

.dq-pill-success {
  background: rgba(25, 135, 84, 0.1);
  border-color: rgba(25, 135, 84, 0.18);
  color: #198754;
}

.dq-pill-warning {
  background: rgba(255, 193, 7, 0.14);
  border-color: rgba(255, 193, 7, 0.22);
  color: #8a6d00;
}

.dq-pill-danger {
  background: rgba(220, 53, 69, 0.1);
  border-color: rgba(220, 53, 69, 0.18);
  color: #dc3545;
}

.dq-pill-info {
  background: rgba(13, 202, 240, 0.14);
  border-color: rgba(13, 202, 240, 0.22);
  color: #0aa2c0;
}

.dq-pill-muted {
  background: rgba(108, 117, 125, 0.12);
  border-color: rgba(108, 117, 125, 0.2);
  color: #6c757d;
}

.dq-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.dq-toolbar-left,
.dq-toolbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* =========================
   Assets List
========================= */
.dq-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dq-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
  transition: 0.15s ease;
}

.dq-list-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 26px rgba(0, 0, 0, 0.08);
}

.dq-list-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
  flex: 1 1 auto;
}

.dq-asset-avatar {
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  color: #fff;
  background: #0d6efd;
  flex: 0 0 auto;
}

.dq-submeta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.55);
  margin-top: 6px;
}

.dq-submeta-strong {
  color: #0d6efd;
  font-weight: 700;
}

.dq-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.dq-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

.dq-spin {
  animation: dqspin 1s linear infinite;
}

@keyframes dqspin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Responsive tweaks */
@media (max-width: 576px) {
  .dq-employee-profile-card .avatar.avatar-xl {
    width: 88px;
    height: 88px;
  }

  .dq-employee-profile-card .justify-content-between {
    gap: 8px;
  }

  .dq-profile-actions > div {
    width: 100%;
  }

  .dq-profile-actions .btn {
    width: 100%;
  }

  .dq-toolbar,
  .dq-toolbar-left,
  .dq-toolbar-right {
    flex-direction: column;
    align-items: stretch;
  }

  .dq-input,
  .dq-input-wide,
  .dq-select {
    min-width: 100%;
    width: 100%;
  }

  .dq-meta {
    grid-template-columns: 1fr;
  }

  .dq-list-item {
    flex-direction: column;
    align-items: stretch;
  }

  .dq-list-right {
    display: flex;
    justify-content: flex-end;
  }
}
</style>


